import { PropsWithChildren } from "react";
import { CellProps } from "react-table";
import { QrCode } from "../../../@types/QrCode";
import { actions } from "constants/qrCodes";

export const ActionCell = ({ cell }: PropsWithChildren<CellProps<QrCode, QrCode["action"]>>) =>
  cell.value ? actions[cell.value.event].displayName : "No action";
